import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

export default function ScrollToTop() {
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: scroll should occur whenever the path changes (but not the search params)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}
